import { IRootState } from '../../../store'
import { ICadImportOptionsState } from '../store/options.types'

export const getCadImportOptionsSelector = (state: IRootState): ICadImportOptionsState => state.options.cadImportOptions
